import { EventEmitter, Injectable, Output, signal} from '@angular/core';
import {Subject, BehaviorSubject, ReplaySubject, Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ChatbotService {
    public act = new BehaviorSubject<any>('mini');
    receivedRowSource = new Subject<any>();
    public size = this.act.asObservable();
    chatbotToken = signal<string|null>(null);
    @Output() public resize = new EventEmitter<string>();

    constructor() {
        this.act.next('mini');
    }

    setChatbotToken (token) {
        this.chatbotToken.set(token);
    }

    getStretch(){
        return this.size;
    }

    stretch(value: string) {
        this.act.next(value);
    }
}